module.exports = __webpack_public_path__ + "img/logo.e91ec0ba.png";